$(document).ready(function () {
  $('.show-navbar-custom').on("click", function() {
    $('.mobile-navbar').addClass('mobile-navbar-visible');
    $('#main-content').addClass('mobile-navbar-filter');
  });
  $('.hide-navbar-custom').on("click", function() {
    $('.mobile-navbar').removeClass('mobile-navbar-visible');
    $('#main-content').removeClass('mobile-navbar-filter');
  });
});
